import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CoursePersistenceService } from '../services/course-persistence.service';
import { CourseDetail } from '../models/courseDetails';
import { CourseService } from '../services/course.service';
import { CourseConstants } from '../constants/course.constants';
import { Prerequisite } from '../models/prerequisites';
import { PrerequisitesData } from '../models/prerequisitesData';

@Component({
  selector: 'app-course-slider',
  templateUrl: './course-slider.component.html',
  styleUrls: ['./course-slider.component.scss']
})
export class CourseSliderComponent implements OnInit{
  @Output() isCourseSliderActive = new EventEmitter<boolean>();
  @Input() isCourseSliderOpen: boolean = false;
  @Input() courseDetails:CourseDetail|undefined;
  activeTab = 0;
  currentTab = 0;
  isEditSlider:boolean=false;
  errorIconClassForTab = '';

  errorIconForGeneralTab='';
  errorIconForPrereqTab='';
  errorIconForTrainingTab='';


    // Lazy load flags
isGeneralTabActive = true;  // General is always visible
isPrerequisitesTabActive = false;
isTrainingMaterialTabActive = false;

  constructor(private coursePersistenceService : CoursePersistenceService,
    private courseService:CourseService){

  }

  ngOnInit(): void {
    this.courseService.editCourseSlider$.subscribe((isEdit)=>{
      this.isEditSlider = isEdit;
      if(isEdit){
        // If Training Material is not null, assign the Values to Variable in Persitence Service
        if(this.courseDetails?.trainingMaterial !== null || this.courseDetails?.trainingMaterial !== undefined)
          this.coursePersistenceService.updateTrainingMaterialDetails(this.courseDetails?.trainingMaterial!)

        // If Course prerequisite is not null, assign the Values to Variable in Persitence Service
        if(this.courseDetails?.prerequisites !== null || this.courseDetails?.prerequisites !== undefined){
          
          // Data Massaging before mapping the Course Prerequisites 
          var prerequisite : Prerequisite[] | null = [];
          this.courseDetails?.prerequisites?.forEach((prerequisiteData: PrerequisitesData) => {
            prerequisite?.push(this.dataMassagingForprerequisites(prerequisiteData));
          });
          
          this.coursePersistenceService.updatePrerequisties(prerequisite)
        }
      }
    });
    this.coursePersistenceService.closeAndResetCourseSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetCourseSlider(); }
    });
    this.coursePersistenceService.populateErrorsForTab$.subscribe((validateTabs) => {
      if(validateTabs) {
        this.showErrorIconForTab();
      }
    });
  }

  dataMassagingForprerequisites(prerequisitesData: PrerequisitesData) : Prerequisite {
    return {
      prerequisiteNumber : prerequisitesData.number,
      prerequisiteType : prerequisitesData.prerequisiteType
    };
  }

  showErrorIconForTab() {
  // reset all icons
  this.errorIconForGeneralTab = '';
  this.errorIconForPrereqTab = '';
  this.errorIconForTrainingTab = '';

  this.coursePersistenceService.errorTabIndices.forEach(tabIndex => {
    if (tabIndex === CourseConstants.Course_Create_General_Tab_Index) {
      this.errorIconForGeneralTab = 'pi pi-exclamation-triangle';
    }

    if (tabIndex === 1) {
      this.errorIconForPrereqTab = 'pi pi-exclamation-triangle';
    }

    if (tabIndex === 2) {
      this.errorIconForTrainingTab = 'pi pi-exclamation-triangle';
    }
  });
}


  closeSlider(){
    this.coursePersistenceService.openConfirmationDialog();
  }

  closeAndResetCourseSlider(){
    this.activeTab = 0
    this.currentTab = 0;
    this.isCourseSliderOpen = false;
    this.coursePersistenceService.onTabChange(-1);
    this.coursePersistenceService.onCustomTabChange(-1);
    this.isCourseSliderActive.emit(this.isCourseSliderOpen);
  }

onTabChange(event: any) {
  this.currentTab = event.index;

  // Always notify persistence service
  this.coursePersistenceService.onTabChange(this.currentTab);
  this.coursePersistenceService.onCustomTabChange(event.index);

  // Lazy-load flags
  switch (event.index) {
    case 0:
      this.isGeneralTabActive = true;
      break;
    case 1:
      this.isPrerequisitesTabActive = true;
      break;
    case 2:
      this.isTrainingMaterialTabActive = true;
      break;
  }
}

  openCurrentTab = (tabIndex: number) => {
    this.currentTab = tabIndex;
    this.activeTab = tabIndex;
  this.lazyLoadTab(tabIndex);

  // emit changes to persistence
  this.coursePersistenceService.onTabChange(tabIndex);
  this.coursePersistenceService.onCustomTabChange(tabIndex);
  }

  lazyLoadTab(index: number) {
  if (index === 0) this.isGeneralTabActive = true;
  if (index === 1) this.isPrerequisitesTabActive = true;
  if (index === 2) this.isTrainingMaterialTabActive = true;
}
}
